import colorConfigs from "../../configs/colorConfigs";

export const orderDetailstyle = {
    container: {
      mt: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      p: 0,
    },
    title: {
      mb: '20px',
      fontWeight: 'bold',
    },
    summaryBox: {
      width: '100%',
      maxWidth: '600px',
      p: '20px',
      backgroundColor: colorConfigs.quaternary,
      borderRadius: '15px',
      boxShadow: 1,
      borderStyle:'solid',
      borderWidth:2,
    },
    headerRow: {
      display: 'flex',
      justifyContent: 'space-between',
      mb: '15px',
      fontWeight: 'bold',
    },
    headerText: {
      fontSize: '16px',
      color: colorConfigs.tertiary,
    },
    itemRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: '10px',
    },
    itemDetails: {
      display: 'flex',
      flexDirection: 'column',
    },
    itemName: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    itemQuantity: {
      fontSize: '12px',
      color: colorConfigs.tertiary,
    },
    itemPrice: {
      fontSize: '14px',
      color: colorConfigs.tertiary,
    },
    subtotalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      mt: '10px',
    },
    subtotalText: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    discountSection: {
      mt: '12px',
      p: '10px 12px',
      borderRadius: '8px',
      backgroundColor: 'var(--color-overlay-black-03)',
    },
    discountTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      mb: '8px',
    },
    discountRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: '8px',
      gap: '12px',
    },
    discountLabel: {
      fontSize: '13px',
      fontWeight: 'bold',
    },
    discountDetail: {
      fontSize: '12px',
      color: colorConfigs.tertiary,
    },
    discountValue: {
      fontSize: '13px',
      fontWeight: 'bold',
      color: colorConfigs.tertiary,
    },
    summaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mt: '8px',
      gap: '12px',
    },
    summaryLabel: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    summaryValue: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: colorConfigs.tertiary,
    },
    paymentRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mt: '10px',
      gap: '12px',
    },
    paymentSummaryRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mt: '10px',
      gap: '12px',
    },
    paymentLabelColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '4px',
      width: '100%',
    },
    paymentLabel: {
      fontSize: '14px',
      fontWeight: 'bold',
      flexShrink: 0,
    },
    paymentSubRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      gap: '12px',
    },
    paymentSubLabel: {
      fontSize: '14px',
      color: colorConfigs.tertiary,
    },
    paymentText: {
      fontSize: '14px',
      textAlign: 'right',
    },
    totalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      mt: '10px',
      fontWeight: 'bold',
    },
    totalLabel: {
      fontSize: '16px',
    },
    totalAmount: {
      fontSize: '16px',
      color: colorConfigs.tertiary, // green color for total
    },
    divider: {
      my: '15px',
    },
    noItemsText: {
      fontSize: '14px',
      color: colorConfigs.tertiary,
    },
  };
  